import htmlLang from '../../utils/htmlLang';
import highlight from '../../common/highlight';

export default {
    name: 'text-message',
    props: ['message', 'keyword', 'height', 'detail'],
    data() {
        return {
            sentStatus: RongIMLib.SentStatus,
        };
    },
    computed: {
        content() {
            let content = this.message.content.content;
            content = htmlLang.check(content);
            content = this.RongIM.common.textMessageFormat(content);
            return highlight(content, this.keyword);
        },
        style() {
            const textStyle = this.height ? `text-overflow:ellipsis;max-height:${this.height};display:block;` : '';
            return this.detail ? textStyle : `${textStyle}overflow:hidden;`;
        },
        containerStyle() {
            return this.detail ? 'overflow-y:auto;height:104px;' : '';
        },
    },
};
